<div class="bg-light funnel py-2 px-3 mb-3">
    <div class="statistics_chart_title">Datos de conversión</div>
    <div class="highchart-chart" id="chartCampaignConversion"></div>
    <div *ngIf="modelStatistics">
        <div class="row statistics_highlights">
            <!-- <div class="col statistics_data">
        <span class="statistics_data_title">Reactividad</span><br> {{reactivity | number : '1.0-0'}}%
      </div> -->
            <div class="col statistics_data">
                <span class="statistics_data_title">Bajas</span><br> {{optout}} ({{optoutPorc | number : '1.0-0'}}%)
            </div>
            <!-- <div class="col statistics_data">
        <span class="statistics_data_title">Facturación</span><br> {{facturacion | currency : 'EUR'}}<br><small>Ticket medio</small><br> ({{facturacionMedia | currency : 'EUR'}})
      </div> -->
        </div>
    </div>
</div>

<app-local-campaign-legend></app-local-campaign-legend>

<div class="row align-items-center pt-2 pb-3">
    <div class=" col-auto">
        <label><strong>Evolución interacción diaria por:</strong></label>
    </div>
    <div class="col-md-2">
        <select2 [(ngModel)]="logTypeSelected" placeholder="Seleccionar interacción" (update)="selectLogType()" [data]="logTypeData"></select2>
    </div>
</div>
<div class="row mb-4">
    <div class="highchart-chart" id="chartCampaignTime">
    </div>
</div>